import type { Theme } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';

const darkModeTheme: Theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#007A8C',
        },
        secondary: {
            main: '#9C27B0',
        },
        error: {
            main: '#D1232C',
        },
        background: {
            default: '#1D2024',
            paper: '#111417',
        },
        text: {
            primary: '#FFFFFF',
        },
        divider: '#27292D',
    }, 
});

export default darkModeTheme;